import { css } from '@emotion/react'
import React, { ReactNode } from 'react'
import { Trans } from '@lingui/macro'
import { Box, Heading, Text } from '@chakra-ui/react'

import { IconSmartScheduling } from 'front-end/src/components/common/icon/IconSmartScheduling'
import Tooltip from 'front-end/src/components/common/tooltip/Tooltip'
import { fontSizes } from 'front-end/src/components/chakraThemeExtension'
import dayjs from 'shared/dayjs'
import { useLooopTheme } from 'front-end/src/public-api/hooks/useLooopTheme'

export const CampaignActionTime: React.FC<{
  timeWithTimezone?: string | null
  smartSchedule?: boolean
  businessHoursEnabled?: boolean
}> = ({ timeWithTimezone, smartSchedule, businessHoursEnabled }) => {
  const { theme } = useLooopTheme()

  let content: ReactNode = null
  if (timeWithTimezone) {
    const timeNoTimezone = timeWithTimezone.split(' ')[0]
    const formattedTime = dayjs(timeNoTimezone, 'HH:mm')
    const tz = timeWithTimezone.split(' ')[1]

    const dayTimeWithTimezone = (
      <>
        {formattedTime.format('LT')}
        <br />
        {tz && <span className="time--offset">{`GMT${tz}`}</span>}
      </>
    )

    if (timeWithTimezone === 'Invalid Date') {
      content = (
        <Trans>
          Date and time <br /> is missing
        </Trans>
      )
    } else {
      const SmartScheduledHeading = (
        <Text fontSize={fontSizes.xs} align="center">
          <Heading size="xs" whiteSpace="normal">
            <Trans>Smart scheduled</Trans>
          </Heading>
        </Text>
      )

      content = (
        <>
          {smartSchedule && (
            <Tooltip
              isBlock
              text={
                <>
                  <Trans>Time for users with no prior activity in looop</Trans>:{' '}
                  {dayTimeWithTimezone}
                </>
              }
            >
              <IconSmartScheduling />
              {SmartScheduledHeading}
            </Tooltip>
          )}
          {!smartSchedule && dayTimeWithTimezone}
          {businessHoursEnabled && (
            <Tooltip
              isBlock
              text={
                <>
                  <Trans>
                    The specific date and time of this action will be set with
                    respect to the business hours setup.
                  </Trans>
                </>
              }
            >
              <Text
                fontSize={fontSizes.sm}
                color={theme.colors.buttonPrimary.default}
              >
                <Trans>
                  in business <br /> hours
                </Trans>
              </Text>
            </Tooltip>
          )}
        </>
      )
    }
  }

  return (
    <Box
      className="time"
      m={'0 4px'}
      width="96px"
      css={css`
        .Tooltip {
          text-align: center;
        }
      `}
    >
      {content}
    </Box>
  )
}
